/**
 * Parse signup API error body into a user-visible string (matches legacy Signup.js semantics).
 */
export async function signupErrorMessageFromResponse(response) {
  const fallback = "Signup failed. Please check your information and try again.";
  if (!response) return fallback;

  try {
    const responseText = await response.clone().text();
    if (!responseText?.trim()) {
      if (response.status === 409) {
        return "An account with this email already exists. Please use a different email or try logging in.";
      }
      if (response.status === 400) {
        return "Invalid information provided. Please check all fields and try again.";
      }
      return fallback;
    }

    try {
      const errorData = JSON.parse(responseText);
      let message = fallback;

      if (errorData?.error) {
        if (typeof errorData.error === "object" && errorData.error !== null) {
          const errorObj = errorData.error;
          if (errorObj.message && errorObj.detail) {
            const msg = String(errorObj.message);
            const detail = String(errorObj.detail);
            if (msg === "Signup validation failed" && detail === "Email already exists") {
              message =
                "This email address is already registered. Please use a different email or try logging in.";
            } else if (msg === "Signup validation failed") {
              message = detail;
            } else {
              message = msg;
            }
          } else if (errorObj.message) {
            message = String(errorObj.message);
          } else if (errorObj.detail) {
            message = String(errorObj.detail);
          }
        } else {
          message = String(errorData.error);
        }
      } else if (errorData?.detail) {
        if (typeof errorData.detail === "string") {
          message = errorData.detail;
        } else if (errorData.detail?.message) {
          message = String(errorData.detail.message);
        } else if (errorData.detail?.detail) {
          message = String(errorData.detail.detail);
        } else {
          message = String(errorData.detail);
        }
      } else if (errorData?.message) {
        message = errorData.message;
      }

      return message;
    } catch {
      if (responseText.length > 0 && responseText.length < 500) {
        return responseText;
      }
    }
  } catch {
    /* ignore */
  }

  if (response.status === 400) {
    return "Invalid information provided. Please check all fields and try again.";
  }
  if (response.status === 409) {
    return "An account with this email already exists. Please use a different email or try logging in.";
  }
  return fallback;
}
